(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/game-limits-deposits-form/assets/react/deposit-limit-dropdown.js') >= 0) return;  svs.modules.push('/components/accountservices-react/game-limits-deposits-form/assets/react/deposit-limit-dropdown.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _svs$ui$ReactDropdown = svs.ui.ReactDropdown,
  DropdownSelectItem = _svs$ui$ReactDropdown.DropdownSelectItem,
  DropdownItem = _svs$ui$ReactDropdown.DropdownItem,
  DropdownLabel = _svs$ui$ReactDropdown.DropdownLabel;
const _React = React,
  useState = _React.useState,
  useEffect = _React.useEffect,
  useRef = _React.useRef;
const Icon = svs.ui.ReactIcon;
const DepositLimitDropdown = _ref => {
  let costOfGame = _ref.costOfGame,
    errorMessage = _ref.errorMessage,
    hasErrorRequired = _ref.hasErrorRequired,
    errorMessageRequired = _ref.errorMessageRequired,
    maxValue = _ref.maxValue,
    minValue = _ref.minValue,
    onSelect = _ref.onSelect,
    period = _ref.period;
  const suggestedLimitsABTest = svs.components.targeting.isTargeted('COT_Insattningsgranser_FastaBelopp', 'B');
  const suggestedLimits = {
    Dagsgräns: 500,
    Veckogräns: 500,
    Månadsgräns: 1000
  };
  const _useState = useState(suggestedLimitsABTest ? suggestedLimits[period] : period),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];

  const firstRender = useRef(true);
  let standardLimits;
  if (maxValue <= 1000 && !firstRender.current) {
    standardLimits = [200, 300, 400, 500, 600, 700, 800, 900, 1000];
  } else if (period === 'Månadsgräns') {
    standardLimits = [200, 500, 1000, 1500, 2000, 2500, 3000];
  } else {
    standardLimits = [200, 300, 400, 500, 600, 800, 1000, 1500, 2000, 2500, 3000];
  }
  const roundedUpCostOfGame = Math.ceil(costOfGame / 100) * 100; 
  const minimumValue = Math.max(roundedUpCostOfGame, minValue || 200) || minValue || 200; 
  const baseArrayKeys = suggestedLimitsABTest ? [1] : [-1, 1]; 
  const _useState3 = useState(baseArrayKeys.concat(standardLimits)),
    _useState4 = _slicedToArray(_useState3, 2),
    limits = _useState4[0],
    setLimits = _useState4[1];

  const shouldNotChangeFields = () => {
    switch (period) {
      case 'Månadsgräns':
        return minValue === suggestedLimits['Veckogräns'];
      case 'Veckogräns':
        return maxValue === suggestedLimits['Månadsgräns'] && minValue === suggestedLimits['Dagsgräns'];
      case 'Dagsgräns':
        return maxValue === suggestedLimits['Veckogräns'];
      default:
        return false;
    }
  };
  useEffect(() => {
    if (!shouldNotChangeFields()) {
      setLimits(baseArrayKeys.concat(standardLimits.filter(standardLimit => standardLimit <= maxValue && standardLimit > minimumValue)));
    }
  }, [minValue, maxValue]); 

  if (maxValue < 3000 && !limits.includes(maxValue) && maxValue > minimumValue) {
    limits.push(maxValue);
  }
  if (!limits.includes(minimumValue)) {
    limits.splice(2, 0, minimumValue);
  }
  let limitTypeIcon;
  let ownLimitText;
  switch (period) {
    case 'Månadsgräns':
      limitTypeIcon = 'calendar-month';
      ownLimitText = 'Välj insättningsgräns per månad';
      break;
    case 'Veckogräns':
      limitTypeIcon = 'calendar-week';
      ownLimitText = 'Välj insättningsgräns per vecka';
      break;
    case 'Dagsgräns':
      limitTypeIcon = 'calendar-day';
      ownLimitText = 'Välj insättningsgräns per dag';
      break;
    default:
      break;
  }
  const dropDownItems = limits.sort((a, b) => a - b).map(limit => {
    if (limit === -1) {
      return React.createElement(DropdownItem, {
        disabled: true,
        key: -1,
        name: period,
        selected: value === period
      }, React.createElement(Icon, {
        icon: limitTypeIcon
      }), React.createElement(DropdownLabel, null, ownLimitText));
    }
    if (limit === 1) {
      return React.createElement(DropdownItem, {
        key: 1,
        name: "own-amount",
        selected: value === 'own-amount'
      }, React.createElement(Icon, {
        color: value === 'own-amount' ? 'fc-green' : '',
        icon: value === 'own-amount' ? limitTypeIcon : 'filter'
      }), React.createElement(DropdownLabel, null, "Skriv eget belopp"));
    }
    return React.createElement(DropdownItem, {
      key: limit,
      name: limit,
      selected: parseInt(value, 10) === limit
    }, parseInt(value, 10) === limit && suggestedLimitsABTest ? React.createElement(Icon, {
      icon: limitTypeIcon
    }) : null, React.createElement(DropdownLabel, null, limit, ' kr'));
  });
  const handleOnSelect = name => {
    setValue(name);
    onSelect(name);
  };
  return React.createElement("div", {
    "aria-invalid": hasErrorRequired || Boolean(errorMessage)
  }, React.createElement(DropdownSelectItem, {
    branding: "default",
    defaultText: period,
    onSelect: handleOnSelect,
    selectLabel: value === period ? '' : period,
    v2: true
  }, dropDownItems), (hasErrorRequired || errorMessage) && React.createElement("div", {
    className: "u-flex dropdown-error"
  }, React.createElement(Icon, {
    color: "fc-red",
    icon: "exclamation-sign",
    size: "200"
  }), React.createElement("p", {
    "aria-live": "assertive",
    className: "margin-bottom-0 f-200"
  }, hasErrorRequired ? errorMessageRequired : errorMessage)));
};
svs.accountservicesReact.gameLimitDepositsForm.DepositLimitDropdown = DepositLimitDropdown;

 })(window);